import { ICSS } from "../../../interfaces/css";
import { ILayout } from "../../../interfaces/layout";
import style from "./style.css";
import { h } from "preact";
import { useState, useEffect } from "preact/hooks";

export interface IPopupLayout extends ILayout {
  type_id: "POPUP";
  ui: {
    content: {};
    css: {
      container: ICSS;
      backDrop: ICSS;
    };
  };
}

interface IProps extends IPopupLayout {
  children: any;
  onClose: Function;
  isActive: boolean;
  startClose?: boolean;
}

export const Popup = (props: IProps) => {
  const { content, css } = props.ui;
  const [isOpen, setOpen] = useState(true);
  const [canShow, toggleShow] = useState(false);

  useEffect(() => {
    if (props.startClose) onClose();
  }, [props.startClose]);

  const prevent = (e: Event) => {
    if (e.cancelable) e.preventDefault();
    e.stopPropagation();
  };

  const onClose = () => {
    setOpen(false);
    toggleShow(false);
  };

  const animeEnd = () => {
    if (!isOpen) {
      toggleShow(false);
      props.onClose();
    } else {
      toggleShow(true);
    }
  };

  return (
    <div
      className={`${style.shellContainer} ${isOpen ? style.open : style.close}`}
    >
      <div className={style.backdrop} style={css.backDrop} onClick={onClose}>
        <div
          className={style.shell}
          style={css.container}
          onAnimationEnd={animeEnd}
        >
          <div
            className={style.children}
            onAnimationEnd={(e) => e.stopPropagation()}
          >
            {canShow ? props.children : null}
          </div>
        </div>
      </div>
    </div>
  );
};
